import {
    Box,
    Button,
    Grid,
    Paper,
    TextField,
    Typography,
    Divider,
    InputAdornment,
    Modal,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
  } from "@material-ui/core";
  import { Info, ChevronLeft } from "@material-ui/icons";
  import { makeStyles } from "@material-ui/core/styles";
  import React, { useState } from "react";
  const initialValuesFromDb ={
      "finished_product_name": "FG Baraclude",
      "customer_finished_product_item_code": "1223158",
      "datalogger_item_code": "N/A",
      "transport_condition_ambient": "Yes",
      "transport_condition_cold_store": "N/A",
        "truck_temperature_prior_to_sealing": "20.6 C°",
        "date_truck_closed_sealed": "05 Jun 2024",
      "document_type": "FinishedProductDispatchCheckList",
      "folder_name": "PCI",
      "site_name": "Dublin",
      "filename": "PCI-Dublin-FinishedProductDispatchCheckList-45152629-C24050.pdf",
      "s3_location": "s3://bms-processed-files/PCI/Dublin/45152629-C24050/PCI-Dublin-FinishedProductDispatchCheckList-45152629-C24050.pdf"
  }

  const useStyles = makeStyles((theme) => ({
    formLabel: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      minWidth: "150px",
      paddingRight: theme.spacing(2),
      textAlign: "right",
    },
    formField: {
      marginBottom: theme.spacing(2),
    },
    requiredStar: {
      color: "red",
      marginLeft: 4,
    },
  }));
  
function FinishedProduct(props) {

    const [isEditable, setIsEditable] = useState(false);
    const [formValues, setFormValues] = useState(initialValuesFromDb);
    const [originalValues] = useState(initialValuesFromDb);
    const [isShowingOriginal, setIsShowingOriginal] = useState(false);
    const [lastSavedValues, setLastSavedValues] = useState(initialValuesFromDb);
    const [openModal, setOpenModal] = useState(false);
    const [modalData, setModalData] = useState({
      field: "",
      before: "",
      after: "",
      updatedBy: "user123",
      timestamp: new Date().toLocaleString(),
    });

    const classes = useStyles();
    const fields = [
      { key: "finished_product_name", label: "Sponsor Description" },
      { key: "customer_finished_product_item_code", label: "Sponsor SKU" },
      { key: "datalogger_item_code", label: "TempTale Serial Number" },
      { key: "truck_temperature_prior_to_sealing", label: "Truck Temperature Before Prior to Sealing" },
      { key: "transport_condition_ambient", label: "Temperature Range and Set Point Transport Condition(Ambient Temperature)+15/+25" },
      { key: "transport_condition_cold_store", label: "Transport Condition(Cold Store)+2/+8" },
      { key: "date_truck_closed_sealed", label: "CMO Readiness Date" },
    ]

  const getLevelColor = (level) => {
    const num = typeof level === "string" ? parseFloat(level) : level;
    if (num < 80) return "red";
    if (num <= 90) return "orange";
    return "green";
  };

  const handleInputChange = (key, value) => {
    let isValid = true;

        // Inline filtering logic
        switch (key) {
          case "finished_product_name":
            isValid = /^[a-zA-Z\s]*$/.test(value); // Allow letters and spaces
            break;
        
            case "customer_finished_product_item_code":
              isValid = /^[0-9]*$/.test(value);
              break;
            case "datalogger_item_code":
              isValid = /^[0-9]*$/.test(value) || value === "N/A" || value === "";
              break;
            
              case "truck_temperature_prior_to_sealing":
                // Allow progressive typing: "20", "20.", "20.6", "20.6 ", "20.6 C", "20.6 C°"
                isValid = /^\d*(\.\d*)?(\s?C?°?)?$/.test(value);
                break;
              
          
                case "date_truck_closed_sealed":
                  // Allow progressive typing for "05 Jun 2024" format
                  if (value === "") {
                    isValid = true;
                  } else if (value.length <= 2) {
                    isValid = /^\d{1,2}$/.test(value);
                  } else if (value.length === 3) {
                    isValid = /^\d{2}\s$/.test(value);
                  } else if (value.length <= 6) {
                    const monthPart = value.substring(3);
                    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                    isValid = /^\d{2}\s/.test(value) && months.some(month => month.toLowerCase().startsWith(monthPart.toLowerCase()));
                  } else if (value.length === 7) {
                    isValid = /^\d{2}\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s$/i.test(value);
                  } else if (value.length <= 11) {
                    isValid = /^\d{2}\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{0,4}$/i.test(value);
                  } else {
                    isValid = false;
                  }
                  break;
                
              case "transport_condition_ambient":
              case "transport_condition_cold_store":
                  isValid = true;
                  break;
          default:
            isValid = true;
        }
    
        if (!isValid) return;
        setFormValues((prev) => ({
          ...prev,
          [key]: value,
        }));
        
      };

  const isFieldChanged = (key) => {
    return formValues[key] !== originalValues[key];
  };
  const renderField = (field) => {
    // Dropdown fields
        if (field.key === "transport_condition_ambient" || field.key === "transport_condition_cold_store") {
      return (
        <select
          value={formValues[field.key] || ""}
          onChange={(e) => handleInputChange(field.key, e.target.value)}
          disabled={!isEditable}
          style={{
            width: "100%",
            height: "40px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            padding: "8px 12px",
            fontSize: "14px",
            backgroundColor: !isEditable ? "#f5f5f5" : "white",
            cursor: !isEditable ? "default" : "pointer",
          }}
        >
          <option value="">Select from dropdown</option>
          <option value="Yes">Yes</option>
          <option value="N/A">N/A</option>
        </select>
      );
    }

    // Regular text fields
    return (
      <TextField
        variant="outlined"
        fullWidth
        size="small"
        value={formValues[field.key] || ""}
        onChange={(e) => handleInputChange(field.key, e.target.value)}
        onBlur={(e) => {
          const { value } = e.target;
          if (field.key === "truck_temperature_prior_to_sealing") {
            const currentValue = formValues[field.key] || "";
            if (/^\d+(\.\d+)?$/.test(currentValue)) {
              // If it's only a number, append °C
              handleInputChange(field.key, `${currentValue}°C`);
            }
          } else {
            // Trim leading and trailing spaces for string values
            if (typeof value === "string" && value.trim() !== value) {
              const trimmedValue = value.trim();
              handleInputChange(field.key, trimmedValue);
            }
          }
        }}
        placeholder={`Enter ${field.label}`}
        InputProps={{
          readOnly: !isEditable,
          endAdornment: (
            <InputAdornment position="end">
              <Box display="flex" alignItems="center" pl={1}>
                <Box
                  style={{
                    width: 1,
                    height: 39,
                    backgroundColor: "#ccc",
                    marginRight: 3,
                  }}
                />
                {!isEditable ? (
                  isFieldChanged(field.key) ? (
                    <Box
                      onClick={() => {
                        setModalData({
                          field: field.label,
                          before: originalValues[field.key],
                          after: lastSavedValues[field.key],
                          updatedBy: "user123",
                          timestamp: new Date().toLocaleString(),
                        });
                        setOpenModal(true);
                      }}
                      style={{
                        backgroundColor: "#7777",
                        color: "white",
                        borderRadius: 4,
                        padding: "2px 8px",
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        minWidth: 24,
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                    >
                      <Info fontSize="small" />
                    </Box>
                  ) : (
                    <Box
                      style={{
                        backgroundColor: "green",
                        color: "white",
                        borderRadius: 4,
                        padding: "2px 8px",
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        minWidth: 24,
                        textAlign: "center",
                      }}
                    >
                      N/A
                    </Box>
                  )
                ) : (
                  <Box
                    style={{
                      backgroundColor: "green",
                      color: "white",
                      borderRadius: 4,
                      padding: "2px 8px",
                      fontSize: "0.75rem",
                      fontWeight: 600,
                      minWidth: 24,
                      textAlign: "center",
                    }}
                  >
                    N/A
                  </Box>
                )}
              </Box>
            </InputAdornment>
          ),
        }}
      />
    );
  };
      
      

    return (
        <div>
            <Grid container direction="column" spacing={2}>
        <Grid item container alignItems="center" spacing={2}>
          <Grid item>
            <Button
              startIcon={<ChevronLeft fontSize="small" />}
              style={{
                fontWeight: "bold",
                textTransform: "none",
                marginLeft: "0px",
              }}
            >
              Back
            </Button>
          </Grid>
          <Grid item>
            <Typography variant="h6">Digitized Finished Product Dispatch Check List</Typography>
          </Grid>
        </Grid>

        <Grid item>
          <Divider
            style={{
              margin: "0px 0px 0px 0px",
              backgroundColor: "#707070",
              height: 1,
              zIndex: 4,
            }}
          />
        </Grid>

        <Grid item container alignItems="center">
          <Grid item>
            <Typography
              variant="h6"
              style={{
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
            >
              Finished Product Dispatch Check List Data
            </Typography>
          </Grid>
          <Grid item style={{ width: "78px" }} />
          <Grid item>
            <Box display="flex" gap={5} style={{ minWidth: "340px" }}>
              <Button
                color="primary"
                variant="outlined"
                onClick={() => {
                  if (isEditable) {
                    setLastSavedValues(formValues);
                  }
                  setIsEditable((prev) => !prev);
                }}
                style={{ minWidth: 15, textAlign: "center" }}
              >
                {isEditable ? "Save Changes" : "Edit"}
              </Button>
              <Grid item style={{ width: "10px" }} />
              <Button
                color="secondary"
                variant="outlined"
                onClick={() => {
                  if (!isShowingOriginal) {
                    setFormValues(originalValues);
                  } else {
                    setFormValues(lastSavedValues);
                  }
                  setIsShowingOriginal(!isShowingOriginal);
                  setIsEditable(false);
                }}
                style={{ minWidth: 20, textAlign: "center", size: "20px" }}
              >
                {isShowingOriginal
                  ? "Show Edited Version"
                  : "Show Unedited Version"}
              </Button>
            </Box>
          </Grid>
          <Grid item style={{ width: "30px" }} />
          <Grid item>
            <Typography variant="h6">PDF Preview</Typography>
          </Grid>
        </Grid>

        <Grid item container spacing={2}>
          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                height: "calc(100vh - 200px)",
                padding: 16,
                overflowY: "auto",
              }}
            >
              {fields.map((field) => (
                <Grid
                  container
                  key={field.key}
                  alignItems="center"
                  spacing={2}
                  className={classes.formField}
                >
                  <Grid item xs={4}>
                    <Typography style={{ paddingRight: 16, fontWeight: 500 }}>
                      {field.label}
                      
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    {/* <TextField
                      variant="outlined"
                      fullWidth
                      size="small"
                      value={formValues[field.key] || ""}

                      onChange={(e) =>
                        handleInputChange(field.key, e.target.value)
                      }
                      onBlur={(e) => {
                        if (field.key === "truck_temperature_prior_to_sealing") {
                          const currentValue = formValues[field.key] || "";

                          if (/^\d+(\.\d+)?$/.test(currentValue)) {
                            // If it's only a number, append °C
                            handleInputChange(field.key, `${currentValue}°C`);
                          }
                        }
                      }}
                      
                      placeholder={`Enter ${field.label}`}
                      InputProps={{
                        readOnly: !isEditable,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Box display="flex" alignItems="center" pl={1}>
                              <Box
                                style={{
                                  width: 1,
                                  height: 39,
                                  backgroundColor: "#ccc",
                                  marginRight: 3,
                                }}
                              />
                              {!isEditable ? (
                                isFieldChanged(field.key)? (
                                  <Box
                                    onClick={() => {
                                      setModalData({
                                        field: field.label,
                                        before: originalValues[field.key],
                                        after: lastSavedValues[field.key],
                                        updatedBy: "user123",
                                        timestamp: new Date().toLocaleString(),
                                      });
                                      setOpenModal(true);
                                    }}
                                    style={{
                                      backgroundColor: "#7777",
                                      color: "white",
                                      borderRadius: 4,
                                      padding: "2px 8px",
                                      fontSize: "0.75rem",
                                      fontWeight: 600,
                                      minWidth: 24,
                                      textAlign: "center",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <Info fontSize="small" />
                                  </Box>
                                ) : (
                                  <Box
                                    style={{
                                      backgroundColor: getLevelColor(
                                        formValues[field.key]?.confidence
                                      ),
                                      color: "white",
                                      borderRadius: 4,
                                      padding: "2px 8px",
                                      fontSize: "0.75rem",
                                      fontWeight: 600,
                                      minWidth: 24,
                                      textAlign: "center",
                                    }}
                                  >
                                    {Math.round(
                                      formValues[field.key]?.confidence
                                    )}
                                  </Box>
                                )
                              ) : (
                                <Box
                                  style={{
                                    backgroundColor: getLevelColor(
                                      formValues[field.key]?.confidence
                                    ),
                                    color: "white",
                                    borderRadius: 4,
                                    padding: "2px 8px",
                                    fontSize: "0.75rem",
                                    fontWeight: 600,
                                    minWidth: 24,
                                    textAlign: "center",
                                  }}
                                >
                                  {Math.round(
                                    formValues[field.key]?.confidence
                                  )}
                                </Box>
                              )}
                            </Box>
                          </InputAdornment>
                        ),
                      }}
                    /> */}
                    
  {renderField(field)}

                  </Grid>
                </Grid>
              ))}

              <Box display="flex" alignItems="center" gap={2} mb={2} mt={3}>
                <Typography variant="body2" color="textSecondary">
                  Confidence Levels Legend:{" "}
                </Typography>
                <Grid item style={{ width: "28px" }} />
                <Box
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 30,
                  }}
                >
                  &gt; 90
                </Box>
                <Box
                  style={{
                    backgroundColor: "orange",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 50,
                    marginLeft: 16,
                  }}
                >
                  80 to 90
                </Box>
                <Box
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    borderRadius: 4,
                    padding: "4px 12px",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    textAlign: "center",
                    minWidth: 30,
                    marginLeft: 16,
                  }}
                >
                  &lt; 80
                </Box>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                height: "calc(100vh - 200px)",
                padding: 16,
                overflowY: "auto",
              }}
            >
              <Box
                style={{
                  height: 500,
                  backgroundColor: "#f5f5f5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px dashed #ccc",
                }}
              >
                <iframe
                  src=""
                  title="PDF Preview"
                  width="100%"
                  height="100%"
                  style={{ border: "none" }}
                />
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Grid>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: 24,
            boxShadow: 24,
            borderRadius: 8,
            minWidth: 600,
          }}
        >
          <Typography variant="h6" gutterBottom>
            {modalData.field} - Field Data History
          </Typography>

          <Table>
            <TableHead
              style={{ border: "1px solid grey", backgroundColor: "#7777" }}
            >
              <TableRow
                style={{ border: "1px solid grey", backgroundColor: "#7777" }}
              >
                <TableCell>
                  <b>Timestamp</b>
                </TableCell>
                <TableCell>
                  <b>Before Value</b>
                </TableCell>
                <TableCell>
                  <b>After Value</b>
                </TableCell>
                <TableCell>
                  <b>Updated By</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{ border: "1px solid grey" }}>
              <TableRow>
                <TableCell>{modalData.timestamp}</TableCell>
                <TableCell>{modalData.before}</TableCell>
                <TableCell>{modalData.after}</TableCell>
                <TableCell>{modalData.updatedBy}</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Box display="flex" justifyContent="center" mt={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenModal(false)}
            >
              OK
            </Button>
          </Box>
        </Box>
      </Modal>
    
            
        </div>
    );
}

export default FinishedProduct;